/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LanguageCommunication } from './';
import {
    LanguageCommunicationFromJSON,
    LanguageCommunicationFromJSONTyped,
    LanguageCommunicationToJSON,
} from './';

/**
 * 
 * @export
 * @interface LanguageCommunicationAvailable
 */
export interface LanguageCommunicationAvailable {
    /**
     * 
     * @type {Array<LanguageCommunication>}
     * @memberof LanguageCommunicationAvailable
     */
    languages: Array<LanguageCommunication>;
}

/**
 * Check if a given object implements the LanguageCommunicationAvailable interface.
 */
export function instanceOfLanguageCommunicationAvailable(value: object): value is LanguageCommunicationAvailable {
    if (!('languages' in value) || value['languages'] === undefined) return false;
    return true;
}

export function LanguageCommunicationAvailableFromJSON(json: any): LanguageCommunicationAvailable {
    return LanguageCommunicationAvailableFromJSONTyped(json, false);
}

export function LanguageCommunicationAvailableFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageCommunicationAvailable {
    if (json == null) {
        return json;
    }
    return {
        
        'languages': ((json['languages'] as Array<any>).map(LanguageCommunicationFromJSON)),
    };
}

export function LanguageCommunicationAvailableToJSON(value?: LanguageCommunicationAvailable | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'languages': ((value['languages'] as Array<any>).map((v) => LanguageCommunicationToJSON(v))),
    };
}

